import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import Article from 'src/smoothr-web-app-core/models/Article';
import { numberD } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-accordion-list',
	templateUrl: './accordion-list.component.html',
	styleUrls: ['./accordion-list.component.scss'],
})
export class AccordionListComponent implements OnInit {
	@Input()
	article: Article;
	@Input()
	defaultOpen: boolean = false;
	@Output()
	change: EventEmitter<string> = new EventEmitter<string>();
	numberD = numberD;
	public isMenuOpen: boolean = false;

	constructor() {}

	ngOnInit() {
		this.isMenuOpen = this.defaultOpen;
	}
	public toggleAccordion(): void {
		this.isMenuOpen = !this.isMenuOpen;
	}
	public broadcastName(name: string): void {
		this.change.emit(name);
	}
	isAllergens() {
		if (!this.article?.compound?.allergens) {
			return null;
		}
		return Object.values(this.article?.compound?.allergens).find(it => it === true);
	}
	isAddit() {
		if (!this.article?.compound?.additives) {
			return null;
		}
		return Object.values(this.article?.compound?.additives).find(it => it === true);
	}
	isTraces() {
		if (!this.article?.compound?.traces) {
			return null;
		}
		return Object.values(this.article?.compound?.traces).find(it => it === true);
	}
	isHaveAnyValueMoreZero(article: any) {
		if (!article.nutritions) {
			return null;
		}

		return Object.values(article.nutritions)
			.map(it => (it ? numberD(it) : -1))
			.filter(it => typeof it === 'number')
			.some(it => +it >= 0);
	}
	// isHaveTrueValue(article: Article) {
	// 	return Object.values(article?.nutritions).find(it => it === true);
	// }
	// isHaveAnyValueMoreZero(article: Article) {
	// 	return Object.values(article.nutritions)
	// 		.map(it => (numberD(it) ? numberD(it) : 0))
	// 		.find(it => it > 0);
	// }

	gramOrMl(article: Article) {
		return article.measurement.unit === 'l' || article.measurement.unit === 'ml' ? 'ml' : 'g';
	}
}
